export default "__VITE_ASSET__CbxenXdo__"